export default "__VITE_ASSET__CxXE9tGR__"